import React from 'react'

export const Info: React.FC = () => {
  return (
    <path d="M5.625 13.2812C5.25 13.2812 5 13.5625 5 13.9062V15.375C5 15.75 5.25 16 5.625 16H10.375C10.7188 16 11 15.75 11 15.375V13.9062C11 13.5625 10.7188 13.2812 10.375 13.2812H9.75V6.625C9.75 6.28125 9.46875 6 9.125 6H5.625C5.25 6 5 6.28125 5 6.625V8.125C5 8.46875 5.25 8.75 5.625 8.75H6.25V13.2812H5.625ZM8 0C6.75 0 5.75 1.03125 5.75 2.25C5.75 3.5 6.75 4.5 8 4.5C9.21875 4.5 10.25 3.5 10.25 2.25C10.25 1.03125 9.21875 0 8 0Z" />
  )
}

export default Info
